<template>
  <Dialog
    custom-class="pg-medical-superAdd"
    :title="modalTitle"
    :visible="visibleSelf"
    :modal="modal"
    :append-to-body="appendToBody"
    width="1150px"
    @close="close"
    @open="init"
  >
    <div class="flex">
      <div class="advanced-left wrap">
        <p class="advanced-left_name">商品分类</p>
        <PgTree
          class="advance-left_tree"
          :data="treeData"
          :treeDefaultProps="treeDefaultProps"
          :filterKeys="treeFilterKeys"
          :parentNode="treeParentNode"
          :defaultExpendKeys="treeDefaultExpendKeys"
        >
          <template slot-scope="scope">
            <span
              :title="scope.data.title ? scope.data.title : scope.data.name"
              :style="{ fontWeight: scope.data.parent === '.' ? 600 : 400 }"
              class="ellipsis1"
              @click="treeCurrentChange(scope.data)"
              >{{
                `${scope.data.code ? '(' + scope.data.code + ')' : ''}${
                  scope.data.title ? scope.data.title : scope.data.name
                }`
              }}</span
            >
          </template>
        </PgTree>
      </div>
      <div class="advanced-right wrap flex flex-v">
        <!-- 高级查询-表单 -->
        <PgCriteriaFormDrawer
          style="flex-shrink: 0"
          v-if="!!queryForm?.items?.length > 0"
          @search="search"
          :formData="queryData"
          :formItems="queryForm"
          @clear="PgCriteriaFormClear"
        ></PgCriteriaFormDrawer>
        <!-- 列表数据为空时展示 -->
        <div v-if="listData.length == 0" class="advanced-right_content"><PgEmpty></PgEmpty></div>
        <!-- 列表数据有时展示 -->
        <div v-else class="advanced-right_content flex flex-v">
          <!-- 全选按钮 -->
          <p class="flex flex-shrink0">
            <i
              class="el-icon-circle-plus pg-medical-superAdd-icon-all"
              @click="emitData(listData)"
            ></i
            >全选
          </p>
          <!-- 列表区域 -->
          <div class="advanced-right_list">
            <div
              class="flex advanced-right_list-item"
              v-for="(option, index) in listData"
              :key="'advanced-right_list_' + index"
              @click="emitData([option])"
            >
              <!-- 左边的选择按钮 -->
              <i class="el-icon-circle-plus pg-medical-superAdd-icon"></i>
              <!-- 右边的展示内容 -->
              <div class="advanced-right_list-content">
                <!-- 第一行标题 -->
                <p class="ar-r_list-content_title">
                  {{ getValue(option, 'name') ?? '-'
                  }}{{ getValue(option, 'commonName') ? getValue(option, 'commonName') : '' }}
                </p>
                <!-- 第二行带背景的属性 -->
                <p class="ar-r_list-content_double">
                  <span
                    v-for="des in optionDescriptionsO"
                    :key="des.key"
                    :class="[{ blockIm: des.block }]"
                    ><label>{{ des.label }}</label
                    >{{ getValue(option, des.key) ?? '-' }}</span
                  >
                </p>
                <!-- 第三行不带背景的属性 -->
                <p class="ar-r_list-content_double">
                  <span
                    v-for="des in optionDescriptionsT"
                    :key="des.key"
                    :class="[{ blockIm: des.block }]"
                    ><label>{{ des.label }}</label
                    >{{ getValue(option, des.key) ?? '-' }}</span
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
        <PgPagination
          :total="listPage.totalCount"
          :pageSize.sync="listPage.pageSize"
          :pageSizes="listPageSizes"
          :current-page.sync="listPage.pageNo"
          @size-change="listSizeChange"
          @current-change="listCurrentChange"
        />
      </div>
    </div>
  </Dialog>
</template>
<script setup>
// vue
import { computed, ref } from 'vue'
// components
import { Dialog } from 'element-ui'
import { PgCriteriaFormDrawer, useCriteriaQueryDrawer } from '../../criteria-form/index'
import { PgEmpty } from '../../empty/index'
import { PgPagination } from '../../pagination/index'
//hook
import { useFlashAddMedical } from '../hook/use-flash-add'
// utils
import { get, post, createID, setValueByPath } from '../../../utils/index'
import { getValueByPath } from '../../../utils/index'

const props = defineProps({
  // -----父组件 dataAdd中拿到的配置数据 --------
  appendToBody: {
    type: Boolean,
    default: true,
  },
  // dialog-默认展示
  modal: {
    type: Boolean,
    default: true,
  },
  //dialog-标题
  modalTitle: {
    type: String,
    default: '高级查询添加商品',
  },
  // dialog-宽度
  width: {
    type: String,
    default: '1150px',
  },
  // 树-获取数据的接口
  treeDataUrl: {
    type: String,
    default: 'rest/main/goods/catalog/selectCatalog',
  },
  // 树-element的一些配置参数
  treeDefaultProps: {
    type: Object,
    default: () => {
      return {}
    },
  },
  // 树-顶部过滤方法，用这三个字段去过滤
  treeFilterKeys: {
    type: Array,
    default: () => {
      return ['name', 'code', 'title']
    },
  },
  // 树-选中节点后需要传递的参数key
  treeParamKey: {
    type: String,
    default: 'catalogId',
  },
  // 树-选中节点后需要传递的参数Path，我们将根据这个path找到需要传递的数据
  treeParamValue: {
    type: String,
    default: 'id',
  },
  // 高级查询-url
  criteriaUrl: {
    type: String,
    default: 'rest/ezcomp/dict/criteria/fetch/',
  },
  // 高级查询-表单一行展示几个元素
  criteriaColumn: {
    type: Number,
    default: 4,
  },
  // 高级查询-code
  criteriaCode: String,
  // 高级查询-默认值
  defaultQueryParameters: Object,
  // 高级查询-其他 参数，可能不显示，但是需要传递在高级查询的参数
  criteriaParams: Object,
  // 右侧下方列表-分页
  listPageSizes: {
    type: Array,
    default: () => {
      return [10, 20, 30, 50]
    },
  },
  listUrl: String,
  listParams: Object,
  // -----从父组件处理后直接传递过来的数据--------
  // 右侧下方列表-数据描述第一行（带背景）
  optionDescriptionsO: Array,
  //右侧下放列表-数据描述第二行（无背景）
  optionDescriptionsT: Array,
})

// -----------------------------hook-------------------------------
const emit = defineEmits([])

// 获取公共方法
const { emitData } = useFlashAddMedical(emit)

// -------------------------左侧分类树---------------------------------------
// 树-数据
const treeData = ref([])
// 树-获取数据接口请求方法
const getTreeData = async () => {
  const [res] = await get(props.treeDataUrl)
  if (res.data) {
    treeData.value = res.data
  }
}

// 树-配置一个‘全部’ 节点，包裹在树的数据最外面
const treeParentNodeId = ref(createID())
const treeParentNode = computed(() => {
  if (treeData.value && treeData.value.length > 0) {
    return {
      id: treeParentNodeId.value,
      parent: '.',
      children: [],
      title: '全部',
    }
  } else {
    return null
  }
})
// 树-默认展开 最外城 全部节点
const treeDefaultExpendKeys = ref([treeParentNodeId.value])

// 树选中的节点
const treeSelectedValue = ref(null)
const treeCurrentChange = (data) => {
  // 如果点击的是’全部‘就不用传递参数了呀
  treeSelectedValue.value = data.title == '全部' ? {} : data
  getListData()
}

// -----------------------------------高级查询---------------------------------------

// 高级查询-表单
const { getCriteria, queryForm, queryData, setQueryForm, updateQueryData, setDefaultQuery } =
  useCriteriaQueryDrawer(
    props.criteriaUrl,
    props.criteriaCode,
    props.criteriaColumn,
    props.defaultQueryParameters
  )

// 高级查询-点击查询按钮触发
const search = () => {
  getListData()
}

// 高级查询-表单-清空
const PgCriteriaFormClear = () => {
  updateQueryData({})
  getListData()
}

//---------------------------------右侧底部数据区域----------------------------------
// 右侧下方-分页
const listPage = ref({
  totalCount: 0,
  pageSize: 10,
  pageNo: 1,
})

const listPageParams = computed(() => {
  const parameters = {
    ...props.listParams?.parameters,
    ...props.defaultQueryParameters,
  }
  // 处理查询参数，为空的不传递
  const keys = Object.keys(queryData.value)
  for (const key of keys) {
    if (queryData.value[key] != '' && queryData.value[key] != null) {
      parameters[key] = queryData.value[key]
    }
  }
  if (treeSelectedValue.value) {
    setValueByPath(
      parameters,
      props.treeParamKey,
      getValue(treeSelectedValue.value, props.treeParamValue)
    )
  }
  return {
    ...listPage.value,
    ...props.listParams,
    ...parameters,
  }
})

const listSizeChange = () => {
  getListData()
}

const listCurrentChange = () => {
  getListData()
}

// 右侧下方列表-数据
const listData = ref([])
// 右侧下方列表-获取数据接口请求方法
const getListData = async () => {
  listData.value = []
  const [res] = await post(props.listUrl, listPageParams.value)
  if (res.data) {
    listData.value = res.data
    listPage.value.totalCount = res.totalCount
  }
}

// -------------------------------通用操作-------------------------------------
const reset = () => {
  // 分页参数置为1
  listPage.value.pageNo = 1
  treeSelectedValue.value = null
}

// 侧滑打开执行函数
const init = () => {
  reset()

  // 获取左侧树的数据 getTreeData  右侧顶部高级查询的表单getCriteria
  // 1.获取高级查询条件
  Promise.all([getTreeData(), getCriteria()]).then(([, resForm]) => {
    setQueryForm(resForm[0]) // 2.设置高级查询-表单
    if (resForm[1]) {
      // 有默认值或者有storage
      updateQueryData(Object.assign(resForm[1], props.criteriaParams))
    } else {
      setDefaultQuery(props.criteriaParams)
    }

    getListData()
  })
}

const visibleSelf = ref(false)

const open = () => {
  visibleSelf.value = true
}

const close = () => {
  visibleSelf.value = false
}

// ------------------------其他------------------------------------------------
const getValue = (data, key) => getValueByPath(data, key)
defineExpose({
  open,
  close,
})
</script>
<style lang="scss">
@import '../style/dialog-add.scss';
</style>
